// console.log("i am here flag1")
import { IEchartOptions } from "@/interfaces/workbench";
import { chartState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";

import { State } from "../state";

export const mutations = {
  setEchartOptions(state: chartState, payload: any) {
    // console.log("i am here flag2.3");
    state.echartOptions = payload;
  },
};

const { commit } = getStoreAccessors<chartState, State>("");
export const commitDrawEChart = commit(mutations.setEchartOptions);
